export default {
	GET_ALL: (crewId) => `/houseItem/list/all?crewId=${crewId}`,
	CREATE: (crewId) => `/houseItem/list?crewId=${crewId}`,
	GENERATE: (crewId) => `/houseItem/list/generate?crewId=${crewId}`,
	DELETE: (id) => `/houseItem/list/${id}`,
	CLEAR: (crewId) => `/houseItem/list/clear?crewId=${crewId}`,
};
